import { render, staticRenderFns } from "./ListExceptionsOVG.vue?vue&type=template&id=5d46e5d8&scoped=true&lang=pug"
import script from "./ListExceptionsOVG.vue?vue&type=script&lang=js"
export * from "./ListExceptionsOVG.vue?vue&type=script&lang=js"
import style0 from "./ListExceptionsOVG.vue?vue&type=style&index=0&id=5d46e5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46e5d8",
  null
  
)

export default component.exports